export default "__VITE_ASSET__dfoO5Ne3__"